<nav class="navbar navbar-top bg-white fixed-top max-width safe-area-top">
  <div class="navbar-top-left">
    <div class="footer-icon flex-content-vc-hc">
      <i class="icon chains-circle" (click)="openMembershipModal()"></i>
    </div>
  </div>

  <ng-container *ngIf="title">
    <div
      class="navbar-brand mr-0 custom-select-navbar-title"
      (click)="titleClick.emit(true)"
    >
      <div class="d-flex">
        <span>{{ title }}</span>
      </div>
    </div>
  </ng-container>

  <div class="navbar-top-right">
    <div class="footer-icon flex-content-vc-hc">
      <i class="icon-v2 share-dark" (click)="onClickShare()"></i>
    </div>
  </div>
</nav>
